/*
  Love'nSpa : lien affilie des fiches non partenaires (template produit-churn).

  Aucune donnee d'affiliation dans Shopify : la source est Lovable (Supabase).
  Le theme demande a la fonction `affiliation` si la fiche a un lien actif,
  et n'affiche le bouton que si c'est le cas. Le bouton pointe vers la
  redirection serveur (`affiliation?p=...&go=1`), jamais vers l'URL CJ :
  le lien peut changer cote Lovable sans toucher au theme, et chaque clic
  est compte cote serveur.

  Contrat attendu de la fonction :
    GET  {base}/affiliation?p={shopify_product_id}
      200 {"plateforme": "Booking.com"}   lien actif
      204                                  pas de lien
    GET  {base}/affiliation?p={id}&go=1   302 vers le lien affilie
*/
(function (root) {
  'use strict';

  // Fonctions pures, testees dans tests/lns-affiliation.test.mjs
  var core = {
    urlInfo: function (base, productId) {
      return base.replace(/\/+$/, '') + '/affiliation?p=' + encodeURIComponent(productId);
    },
    urlGo: function (base, productId) {
      return core.urlInfo(base, productId) + '&go=1';
    },
    // Accepte uniquement une plateforme non vide, bornee, sans balisage.
    plateformeValide: function (data) {
      if (!data || typeof data.plateforme !== 'string') return null;
      var p = data.plateforme.trim();
      if (!p || p.length > 40 || /[<>"']/.test(p)) return null;
      return p;
    }
  };
  root.LNS_AFFILIATION = core;

  if (typeof document === 'undefined') return;

  function init() {
    var boites = document.querySelectorAll('[data-lns-affiliation]');
    Array.prototype.forEach.call(boites, function (boite) {
      var base = boite.getAttribute('data-base');
      var pid = boite.getAttribute('data-product-id');
      if (!base || !pid || !window.fetch) return;

      fetch(core.urlInfo(base, pid), { method: 'GET', credentials: 'omit' })
        .then(function (r) { return r.status === 200 ? r.json() : null; })
        .then(function (data) {
          var plateforme = core.plateformeValide(data);
          if (!plateforme) return;
          var lien = boite.querySelector('[data-lns-affiliation-lien]');
          var nom = boite.querySelector('[data-lns-affiliation-nom]');
          if (!lien || !nom) return;
          nom.textContent = plateforme;
          lien.href = core.urlGo(base, pid);
          lien.addEventListener('click', function () {
            try {
              var track = window.LNS_FUNNEL && window.LNS_FUNNEL.track;
              if (typeof track === 'function') {
                track('outbound_booking_click', { mode: 'affiliation', domaine: plateforme.toLowerCase() }, { immediat: true, beacon: true });
              }
            } catch (e) { /* jamais bloquant */ }
          });
          boite.hidden = false;
        })
        .catch(function () { /* pas de bouton, la page reste utilisable */ });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(typeof window !== 'undefined' ? window : globalThis);
